import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const dropdown = (theme: Theme) => css`
  ${breakpoint.up('lg')} {
    position: absolute;
    top: 100%;
    left: -30px;
    display: block;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-10px);
    transition:
      opacity 0.2s ease-out,
      transform 0.2s ease-out;
    z-index: 12;

    background: ${theme.palette.background.main};
    border-radius: ${size[8]} ${size[32]};
    box-shadow: 0 10px 40px rgba(130, 139, 153, 0.4);
    padding: ${size[54]};
    width: fit-content;
    max-width: calc(100vw - 15px);
    overflow: hidden;

    &::before {
      content: '';
      height: 6px;
      background: ${theme.palette.primary.mainContrast};
      width: 90px;
      display: block;
      position: absolute;
      border-radius: 3px;
      top: -3px;
      left: 30px;
    }
  }
`

export const content = css`
  display: flex;
  flex-direction: column;
  gap: ${size[28]};
`

export const inlineContent = css`
  ${breakpoint.up('lg')} {
    flex-direction: row;
  }
`

export const list = css`
  a span {
    color: #1a0826;
  }
`
